import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaShowHide from '@sparta.global.utilities/sparta-show-hide-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { showHide, showHideList } from '@sparta.global.helpers/show-hide-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"intro\"><h2>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"intro") || (depth0 != null ? lookupProperty(depth0,"intro") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"intro","hash":{},"data":data,"loc":{"start":{"line":11,"column":29},"end":{"line":11,"column":40}}}) : helper))) != null ? stack1 : "")
    + "</h2></div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasShowHide")),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":6},"end":{"line":17,"column":13}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"showHide")||(depth0 && lookupProperty(depth0,"showHide"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"content") : depths[1])) != null ? lookupProperty(stack1,"label") : stack1),{"name":"showHide","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":8},"end":{"line":16,"column":21}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"details\"><p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"details") || (depth0 != null ? lookupProperty(depth0,"details") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"details","hash":{},"data":data,"loc":{"start":{"line":15,"column":34},"end":{"line":15,"column":47}}}) : helper))) != null ? stack1 : "")
    + "</p></div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n\r\n<div class=\"row\">\r\n  <div class=\"small-12 medium-10 large-8 medium-centered column\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"pageID") : stack1),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":10,"column":12},"end":{"line":10,"column":40}}}),{"name":"with","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":4},"end":{"line":18,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>\r\n";
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/more-less-cc-module",
  "version": "1.0.3",
  "id": "moreLessCcModule",
  "containerID": "creditCardsMoreLessCcModule",
  "moduleName": "credit-cards-more-less-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "more-less-cc-module",
  "data": {
    "init": "moreLessCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "hasShowHide",
    "values": [true, false],
    "default": true,
    "description": "Has Sparta Show / Hide component"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        showHide,
        showHideList
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    showHide,
    showHideList
  },
  "dependencies": {
    "@sparta.global.helpers/show-hide-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-show-hide-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/*
 * more-less-cc-module
 * module_js_id: moreLessCcModuleJS
 *
 * Copyright (c) 2017-12-5 removed
 */

/**
 * @export
 * @class moreLessCcModuleJS
 * @extends {Module}
 */
class moreLessCcModuleJS extends Module {
  /**
   * Creates an instance of moreLessCcModuleJS.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof moreLessCcModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Initialize module
   * @returns {void}
   */
  init() {
    const {
      hasShowHide
    } = this.params;
    if (hasShowHide) {
      spartaShowHide.init();
    }
  }
}
registerModuleClass({
  moduleClass: moreLessCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { moreLessCcModuleJS as default, moduleConfig };
